<template>
  <div class="config-table">
    <el-table :data="rewardTypeList" style="width: 450px;flex-basis: 320px;" height="920">
      <el-table-column prop="value" label="奖励类型"></el-table-column>
      <el-table-column prop="label" label="奖品名"></el-table-column>
      <el-table-column prop="typeId" label="类型关联id"></el-table-column>
      <el-table-column prop="other" label="单位数量"></el-table-column>
    </el-table>
    <el-alert title="说明" type="success" style="width: 300px; height: 200px; margin: 40px 200px;"
      :closable="false">
      <p v-for="item in contain" style="line-height: 1.3;">{{ item }}</p>
    </el-alert>
  </div>
</template>
<script>
import { rewardTypeList } from './reward'
export default {
  data() {
    return {
      rewardTypeList,
      contain: [`数量、天数、积分在配置奖励内容时无法配置对应参数`,
        `未带数量天数积分在配奖励内容时可自由配置`,
        `装扮需在房间物品配登表配奖励内容
        (应用类型选活动)`,
        `礼物奖励需在礼物配置表配首奖励内容（应用类型选活动）`]
    }
  }
}
</script>
<style scoped lang="scss">
.config-table {
  display: flex;
}
</style>

<style>
.el-alert__title {
  font-size: 40px;
}
</style>